export type TradeInvoiceType = 'Provisional' | 'Final Settlement';

export function normalizeTradeType(raw: string | null): TradeInvoiceType | null {
  if (raw === null) return null;
  if (raw === 'Provisional') return 'Provisional';
  if (raw === 'Final_Settlement' || raw === 'Final Settlement') return 'Final Settlement';
  return null;
}
